import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// Use this throughout the application rather than useDispatch and useSelector
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
